import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: '/gascaribe/transactions',
          role: 'file_transfer_gascaribe',
        },
        gasguajira: {
          path: '/gasguajira/transactions',
          role: 'file_transfer_gasguajira',
        },
        efigas: {
          path: '/efigas/transactions',
          role: 'file_transfer_efigas',
        },
      }}
    />
  );
};

export default Home;
